import type { ReactNode } from "react";
import { EmptyState } from "../../ui/empty-state";
import { workspaceText } from "../i18n";
import type { WorkspaceLocale } from "../i18n";

export interface UnavailableWorkspaceComponentProps {
  /** The raw, unrecognised component id. Rendered as text only — never interpolated into markup/eval, safe for an arbitrary/malicious string. */
  readonly componentId: string;
  readonly locale?: WorkspaceLocale | undefined;
}

export function UnavailableWorkspaceComponent({
  componentId,
  locale = "en",
}: UnavailableWorkspaceComponentProps): ReactNode {
  return <EmptyState description={componentId} title={workspaceText(locale, "workspaceUnavailable")} />;
}
